export default class ResizeFlickityInnerSlider {
    constructor(innerSlider) {
        if (!innerSlider) return;

		let flickity_options = {};

		// Get data-flickity from HTML.
		if (innerSlider.getAttribute('data-flickity')) {
			flickity_options = JSON.parse(innerSlider.getAttribute('data-flickity'));
		}

		let flkty = new Flickity( innerSlider, flickity_options );
		// layout Masonry

		// Fix conflict between pswp and flickity (scroll, touch)
		flkty.on('dragStart', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'none';
			});
		});

		flkty.on('dragEnd', function () {
			this.cells.forEach((cell) => {
				cell.element.style.pointerEvents = 'all';
			});
		});
    }
}
